import { gql } from '@apollo/client';

const SAVE_OFAC_REVIEW = gql`
  mutation SaveOfacReview(
    $agentId: String!
    $applicationId: String!
    $notes: String!
    $outcome: String!
  ) {
    saveOfacReview(
      agentId: $agentId
      applicationId: $applicationId
      notes: $notes
      outcome: $outcome
    ) {
      outcome
    }
  }
`;

export { SAVE_OFAC_REVIEW };
